import { render, staticRenderFns } from "./ExerciseByCategoryList.vue?vue&type=template&id=b2f860b4&"
import script from "./ExerciseByCategoryList.vue?vue&type=script&lang=js&"
export * from "./ExerciseByCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports